let initialized = false;

function switchTab(id: string): void {
    const tab = document.getElementById(`tab_${id}`) as HTMLInputElement | null;
    if (tab) tab.checked = true;
}

export function initTabCustom(): void {
    if (initialized) return;
    initialized = true;
    document.addEventListener('click', function (e) {
        const a = (e.target as Element).closest('a[href^="#"]');
        if (!a) return;
        const id = a.getAttribute('href')!.slice(1);
        if (document.querySelector(`.tabs #${id}`)) switchTab(id);
    });
}
